import { Button, Flex, Row } from "antd";
import useWepapp from "../hook/useWepapp";
import { useMediaQuery } from "react-responsive";

const { Outlet } = require("react-router-dom")

const CompleteComponent = ({
    headPart = () => { },
    first = () => { },
    second = () => { },
    third = () => { },
    navBar = () => { },


}) => {
    const { goToMenu = () => { } } = useWepapp()
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    return (
        <Flex vertical style={{ display: "flex", flexDirection: "column", height: isPortrait ? "100vh" : "100vw", backgroundColor: "#FCF9F6" }} >
            {/* <h1>{p8}</h1>
            <Button onClick={() => goToMenu("history")}> Go to history</Button> */}

            <Flex vertical style={{ padding: isPortrait ? "5vh" : "7.5vh", height: "100%", gap: isPortrait ? "2vh" : "4vh" }}>
                {headPart()}
                {first()}
                {second()}
                {third()}
            </Flex>
            {navBar()}
        </Flex >
    )
}
export default CompleteComponent;